import { api } from './client.js';

/*
 * Every route the frontend calls, in one file. Query keys live here too so a
 * mutation can invalidate exactly what it changed without a component having to
 * remember the key shape.
 */

export const queryKeys = {
  stages: ['stages'],
  teachers: ['teachers'],
  testimonials: ['testimonials', 'homepage'],
  enquiries: (filters) => ['enquiries', filters],
  enquiryStats: ['enquiries', 'stats'],
};

export const contentApi = {
  stages: () => api.get('/stages'),
  teachers: () => api.get('/teachers'),
  homepageTestimonials: () => api.get('/testimonials/homepage'),
};

export const enquiriesApi = {
  /** Public — this is what the admissions form posts. */
  submit: (payload) => api.post('/enquiries', payload),

  list: ({ page = 1, limit = 25, status, stage, search } = {}) => {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (status) params.set('status', status);
    if (stage) params.set('stage', stage);
    if (search) params.set('search', search);

    return api.get(`/enquiries?${params}`, { auth: true });
  },

  stats: () => api.get('/enquiries/stats', { auth: true }),
  get: (id) => api.get(`/enquiries/${id}`, { auth: true }),

  updateStatus: (id, { status, internalNote }) =>
    api.patch(
      `/enquiries/${id}/status`,
      // The API rejects unknown properties, so only send what changed.
      internalNote ? { status, internalNote } : { status },
      { auth: true },
    ),

  remove: (id) => api.delete(`/enquiries/${id}`, { auth: true }),
};

export const authApi = {
  login: (credentials) => api.post('/auth/login', credentials),
  logout: () => api.post('/auth/logout', undefined, { auth: true }),
  me: () => api.get('/auth/me', { auth: true }),
};
